import { getApiNoAuth } from "../genericServices"

export async function getEvento() {
  return await getApiNoAuth('eventi?eventoId=1');
}